import { useState, useEffect} from 'react'
import { Box, Grid, Typography, List, ListItemButton, ListItemText, Select, MenuItem, Button, Divider, Container, Alert, useMediaQuery } from '@mui/material'
import { useAppData } from '../../redux/appDataProvider'
import { format } from 'date-fns'
import dayjs from "dayjs"
import ApiClient from "../../utilities/apiClient"
import AppConfig from "../../AppConfig"
import { useSelector } from 'react-redux'
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DatePicker } from "@mui/x-date-pickers"
import exportFromJSON from 'export-from-json'
const data = {
//   "Tax P&L": [
//     "Stocks - Capital gains",
//     "F&O - Tax report",
//   ],
  Holdings: ["Stocks - Holdings statement"],
  Contract:["Contract - Note"]
}


const Contract = () => {
  const isSmallScreen = useMediaQuery('(max-width : 900px)')
  const { selectedYear } = useAppData()
  const { userInfo } = useAppData()
  const { userFnYear } = useAppData([])
  const apiToken = useSelector(state => state.auth.apiToken)

  const [tdate, SetTDate] = useState(dayjs(new Date()))
  const [fromDate, setFromDate] = useState(dayjs())
  const [toDate, setToDate] = useState(dayjs())
  const [error, setError] = useState('')
  const [selectedReport, setSelectedReport] = useState("Stocks - Holdings statement");
  const [selectFnYear, setSelectFnYear] = useState(
    userFnYear && userFnYear.length > 0
      ? userFnYear[userFnYear.length - 1].Database_Year
      : new Date().getFullYear().toString()
  )
  const [loader,setLoader]=useState(false)

  const setFromDateToDate = async (year) => {
    const currentYear = parseInt(year) - 1

    let financialYearStart, financialYearEnd;
    let aa = 0
    aa = parseInt(currentYear) + 1
    financialYearStart = "01/04/" + currentYear
    financialYearEnd = "31/03/" + aa

    let fd = financialYearStart.split("/").reverse().join("-")
    let td = financialYearEnd.split("/").reverse().join("-")

    setFromDate(fd)
    setToDate(td)

  }

  useEffect(() => {
    setFromDateToDate(selectedYear.Database_Year)
    setSelectFnYear(selectedYear.Database_Year)
  }, [selectedYear.Database_Year])

  const downloadFile = (content, filename, contentType) => {
    const blob = new Blob([content], { type: contentType });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  };

  const ExportDistWise = (data) => {
    const fileName = `Holdings_${userInfo.CLIENT_ID}`
    const exportType = exportFromJSON.types.csv
    exportFromJSON({ data, fileName, exportType })
  }


  const handleEquityDownload = () => {
    try {
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.TaxPAndL.equityTaxPandL,
        "POST",
        {
          "annualPL": {
            "Client_code": userInfo.CLIENT_ID ? userInfo.CLIENT_ID : localStorage.getItem("userid"),
            "ToDate": dayjs(toDate).format("DD/MM/YYYY"),
            "WithExp": "Y",
            "Profit": "A",
            "COCD": "NSE_CASH",
            "datayear": `${dayjs(fromDate).year()}`,
            "Logic_LTCG": "Y"
          },
          "clientInfo": {
            "Client_code": userInfo.CLIENT_ID ? userInfo.CLIENT_ID : localStorage.getItem("userid"),
            "FromDate": dayjs(fromDate).format("DD/MM/YYYY"), "ToDate": dayjs(toDate).format("DD/MM/YYYY"),
            "panNumber": userInfo?.PAN_NO,
            "clientName": userInfo.CLIENT_NAME
          }
        })
        .then((response) => {
          if (!response) {
            console.log("Error: Equity Tax Response is missing.");
            return;
          }

          if (response.status === 200 && response.data?.data) {
            const filename = `Stocks_Capital_Gains_TaxP&L_${userInfo.CLIENT_ID}.xlsx`

            // Convert the buffer from response into a Uint8Array
            const bufferData = new Uint8Array(response.data.data)

            downloadFile(
              bufferData,
              filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`,
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )
            setError('')

          } else if (response.status === 500) {
            const errorMessage = response.statusText || (response.details && response.details["Error Description"].replace("Database Error: ", "")) || response.error
            setError(errorMessage);
            console.log("Error 500 during Equity  API request: ", response)
          } else {
            console.log("Unexpected response status:", response.status);
          }
        })
        .catch((error) => {
          console.error("Error during Equity API request:", error);
        });
    } catch (error) {
      console.error('Error fetching Equity Tax PDF:', error)
    }
  }

  const handleFnODownload = () => {
    try {
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.TaxPAndL.fnoTaxPandL,
        "POST",
        {
          "multiDateOS": {
            "COMPANY_CODE": "NSE_FNO",
            "FROM_DATE": dayjs(fromDate).subtract(4, "day").format("DD/MM/YYYY"),
            "TO_DATE": dayjs(toDate).subtract(4, "day").format("DD/MM/YYYY"),
            "client_code": userInfo.CLIENT_ID ? userInfo.CLIENT_ID : localStorage.getItem("userid"),
            "Option_Op_Price": "Y",
            "FUTURE_OP_PRICE": "Y"
          },
          "clientInfo": {
            "Client_code": userInfo.CLIENT_ID ? userInfo.CLIENT_ID : localStorage.getItem("userid"),
            "FromDate": dayjs(fromDate).format("DD/MM/YYYY"), "ToDate": dayjs(toDate).format("DD/MM/YYYY"),
            "panNumber": userInfo?.PAN_NO,
            "clientName": userInfo.CLIENT_NAME
          }
        })
        .then((response) => {
          if (!response) {
            console.log("Error: FnO Tax Response is missing.");
            return;
          }

          if (response.status === 200 && response.data?.data) {
            const filename = `FnO_TaxP&L_${userInfo.CLIENT_ID}.xlsx`

            // Convert the buffer from response into a Uint8Array
            const bufferData = new Uint8Array(response.data.data)

            downloadFile(
              bufferData,
              filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`,
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )
            setError('')
          } else if (response.status === 500) {
            const errorMessage = response.statusText || (response.details && response.details["Error Description"].replace("Database Error: ", "")) || response.error
            setError(errorMessage);
            console.log("Error 500 during FnO API request: ", response)
          } else {
            console.log("Unexpected response status:", response.status);
          }
        })
        .catch((error) => {
          console.error("Error during FnO API request:", error);
        });
    } catch (error) {
      console.error('Error fetching FnO Tax xlsx:', error)
    }
  }

  const handleHoldingsDownload = async () => {
    console.log("tdate",tdate)
    try {
      setLoader(true)
      const apiClient = new ApiClient(apiToken)
      apiClient.fetchData(
        AppConfig.api.Depository.dpholding,
        "POST",
        {
          "Client_code": userInfo.CLIENT_ID ? userInfo.CLIENT_ID : localStorage.getItem("userid"),
          "To_date": tdate.format('DD/MM/YYYY'),
          "BO_ID": userInfo?.CLIENT_DP_CODE,
          "DatabaseName": "Depository",
          "Cocd": "CDSL"
        })
        .then((response) => {
          console.info(response);
          if (!response) {
            setLoader(false)
            console.log("Error: Holdings Response is missing.");
            return;
          }

          if (response && response.Success === "True" && response.hasOwnProperty("Success Description")) {
            let responseData = response["Success Description"]
            console.info(`data ${responseData}`)
            setLoader(false)
            if (Array.isArray(responseData) && responseData.length > 0) {

              let result = responseData.map(data => {
                return {
                  SCRIP_SYMBOL: data.BSE_SHORT_NAME,
                  NET: data.NET,
                  PURCHASE_PRICE: data.PURCHASE_PRICE,
                  BUYVAL: (data.NET * data.PURCHASE_PRICE).toFixed(4),
                  SCRIP_VALUE: data.SCRIP_VALUE,
                  AMOUNT: data.AMOUNT,
                  PANDL: (data.AMOUNT - (data.NET * data.PURCHASE_PRICE)).toFixed(4),
                  PERCENT_HOLD: data.PERCENT_HOLD,
                  SCRIP_NAME: data.SCRIP_NAME
                }
              })

              ExportDistWise(result)
              setError('')
            }
          } else if (response.Success === "False") {
            setLoader(false)
            const errorMessage = response["Error Description"].replace("Database Error: ", "")
            setError(errorMessage)
            console.log("Error 500 during Holdings API request: ", response)
          } else {
            setLoader(false)
            console.log("Unexpected response status:", response.status)
          }
        })
        .catch((error) => {
          setLoader(false)
          console.error("Error during Holdings API request:", error)
        });
    } catch (error) {
      setLoader(false)
      console.error('Error fetching holdings data:', error)
    }
  };

    const handleContractDownload = async () => {
        try {
            setLoader(true)
            const apiClient = new ApiClient(apiToken);

            const payload = {
                cl: userInfo.CLIENT_ID ? userInfo.CLIENT_ID : localStorage.getItem("userid"),
                frDt: tdate.format("DD/MM/YYYY"),
                toDt: tdate.format("DD/MM/YYYY"),
                grp: "GRP1",
                CLIENT_NATURE: "c",
                // MARKET_TYPE: "",
                type: "json",
                // panno:userInfo?.PAN_NO
            };

            apiClient.fetchData(
                AppConfig.api.Contract.downloadPDF,
                "POST",
                payload
            )
                .then((response) => {
                    if (!response || response.status === 204) {
                        setLoader(false)
                        setError("No contract note found");
                        return;
                    }

                    if (response?.data?.Success === "False") {
                      setLoader(false)
                        setError(
                            response?.data?.["Error Description"] || "No contract data found"
                        );
                        return;
                    }

                    const base64PDF = response.data || response;
                    const binaryString = window.atob(base64PDF);
                    const bytes = new Uint8Array(binaryString.length);

                    for (let i = 0; i < binaryString.length; i++) {
                        bytes[i] = binaryString.charCodeAt(i);
                    }

                    const filename = `Contract_${tdate.format("YYYYMMDD")}.pdf`;

                    downloadFile(bytes, filename, "application/pdf");
                    setLoader(false)
                    setError("");
                })
                .catch((error) => {
                  setLoader(false)
                    console.error("Contract API error:", error);
                    setError("Failed to download contract note");
                });
        } catch (error) {
          setLoader(false)
            console.error("Contract download failed:", error);
            setError("Failed to download contract note");
        }
    };



  return (
    <Container sx={{ background: "#0B1420", minHeight: "100vh", py: 5, px: 3 }}>
      <Box sx={{ p: 2 }}>
        <Grid container spacing={2}>
          {/* Sidebar */}
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              p: 1,
              mb: { xs: 2, md: 0 },
            }}
          >
            {Object.keys(data).map((category) => (
              <Box key={category} sx={{ mb: 2 }}>
                <Typography
                  component="h2"
                  variant="h6"
                  sx={{ mb: 1, color: "#fff" }}
                >
                  {category}
                </Typography>
                <List sx={{ p: 0 }}>
                  {data[category].map((report, index) => (
                    <Box key={report}>
                      <ListItemButton
                        selected={selectedReport === report}
                        onClick={() => {
                          setSelectedReport(report);
                        }}
                        sx={{
                          pl: 2,
                          color: "#fff",
                          justifyContent: "space-between",
                          backgroundColor:
                            selectedReport === report ? "#1B222C" : "transparent",
                          "&:hover": {
                            backgroundColor: "#1B222C",
                          },
                          "&.Mui-selected": {
                            backgroundColor: "#1B222C !important",
                            "&:hover": {
                              backgroundColor: "#1B222C !important",
                            },
                          },
                        }}
                      >
                        <ListItemText
                          primary={report}
                          primaryTypographyProps={{
                            fontSize: { xs: '14px', sm: '16px' }
                          }}
                        />
                        <Typography sx={{ ml: 1 }}>{">"}</Typography>
                      </ListItemButton>

                      {/* silver divider line */}
                      {index < data[category].length - 1 && (
                        <Divider sx={{ my: 0, borderColor: "#C0C0C0" }} />
                      )}
                    </Box>
                  ))}
                </List>
              </Box>
            ))}
          </Grid>


          {/* Content Panel */}
          <Grid item xs={12} md={8} style={{ paddingLeft: isSmallScreen && '0px' }}>
            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 1,
                p: 2,
                minHeight: 100,
              }}
            >
              <Typography variant="h6" sx={{ mb: 2, fontSize: '18px' }}>
                {selectedReport}
              </Typography>
              {['Capital', 'F&O'].some(k => selectedReport.includes(k)) && (<>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    Choose financial year
                  </Typography>
                  <Select
                    value={selectFnYear}
                    onChange={(e) => {
                      setSelectFnYear(e.target.value)
                      setFromDateToDate(e.target.value)
                    }}
                    fullWidth
                    sx={{
                      height: 36, // smaller height
                      fontSize: 14,
                      '& .MuiSelect-select': {
                        py: 0.5, // reduces vertical padding
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          '& .MuiMenuItem-root': {
                            minHeight: '28px',
                            fontSize: '14px',
                            py: 0.5,
                          },
                        },
                      },
                    }}
                  >
                    {userFnYear.map((item) => {
                      const start = new Date(item.start_date);
                      const end = new Date(item.End_date)
                      const displayLabel = `${format(start, 'MMM yyyy')} - ${format(end, 'MMM yyyy')}`;
                      return (
                        <MenuItem key={item.Database_Year} value={item.Database_Year}>
                          {displayLabel}
                        </MenuItem>
                      )

                    })}
                  </Select>
                </Box>

                <Button variant="contained"
                  size="medium" onClick={selectedReport.includes("Capital gains") ? handleEquityDownload : handleFnODownload}
                  sx={{ width: 150, height: 40, fontWeight: "bold" }}
                >
                  Download
                </Button>
              </>)}

              {['Holdings'].some(k => selectedReport.includes(k)) && (<>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    Choose date
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="To Date"
                      value={tdate}
                      onChange={(newValue) => SetTDate(newValue)}
                      format="DD/MM/YYYY"
                      maxDate={dayjs()} // current day only
                      slotProps={{ textField: { size: "small" } }}
                      sx={{
                        height: 40,
                        mt: 1,
                        backgroundColor: "#131E2E",
                        "& .MuiInputBase-root": { height: 40 },
                        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                        "& .MuiInputBase-input": { fontSize: "14px", },
                        "& .MuiInputLabel-root": { fontSize: "14px", }
                      }}
                    />
                  </LocalizationProvider>

                </Box>

                <Button variant="contained"
                  disabled={loader}
                  size="medium" onClick={handleHoldingsDownload}
                  sx={{ width: 150, height: 40, fontWeight: "bold" }}
                >
                  {loader ? "Downloading" :"Download"}
                </Button>
              </>)}

                          {['Contract'].some(k => selectedReport.includes(k)) && (
                              <>
                                  <Box sx={{ mb: 2 }}>
                                      <Typography variant="body2" sx={{ mb: 1 }}>
                                          Choose date
                                      </Typography>

                                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                                          <DatePicker
                                              label="Contract Date"
                                              value={tdate}
                                              onChange={(newValue) => SetTDate(newValue)}
                                              format="DD/MM/YYYY"
                                              maxDate={dayjs()}
                                              slotProps={{ textField: { size: "small" } }}
                                              sx={{
                                                  height: 40,
                                                  mt: 1,
                                                  backgroundColor: "#131E2E",
                                                  "& .MuiInputBase-root": { height: 40 },
                                                  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                                                  "& .MuiInputBase-input": { fontSize: "14px" },
                                                  "& .MuiInputLabel-root": { fontSize: "14px" },
                                              }}
                                          />
                                      </LocalizationProvider>
                                  </Box>

                                  <Button
                                      variant="contained"
                                      size="medium"
                                      onClick={handleContractDownload}
                                      disabled={loader}
                                      sx={{ width: 180, height: 40, fontWeight: "bold" }}
                                  >
                                   {loader ? "Downloading" :"Download Contract"}
                                  </Button>
                              </>
                          )}


            </Box>

          </Grid>

          {/* Error message  */}
          <Grid item xs={12}>
            {error && (
              <Alert severity="warning" style={{ background: 'transparent', padding: 0 }}>
                {error.toLocaleLowerCase() === 'data not found' ? 'No Transactions found !' : error}
              </Alert>
            )}

          </Grid>

        </Grid>
      </Box>
    </Container>
  );
};

export default Contract;
